let db: IDBDatabase
const DB_NAME = "tracelium"
const DB_VERSION = 3

export enum Stores {
  Conversations = "conversations",
  AdditionalInfo = "addtional_infos",
  ExtraInfo = "extra_infos",
  PrivateKeys = "private_keys",
  DownloadFile = "download_file_queue",
}

export const initDB = (): Promise<IDBDatabase> => {
  return new Promise((resolve, reject) => {
    const request = indexedDB.open(DB_NAME, DB_VERSION)

    request.onupgradeneeded = () => {
      const upgradeDB = request.result

      if (!upgradeDB.objectStoreNames.contains(Stores.Conversations)) {
        upgradeDB.createObjectStore(Stores.Conversations, { keyPath: "id" })
      }
      if (!upgradeDB.objectStoreNames.contains(Stores.AdditionalInfo)) {
        upgradeDB.createObjectStore(Stores.AdditionalInfo, { keyPath: "id" })
      }
      if (!upgradeDB.objectStoreNames.contains(Stores.ExtraInfo)) {
        upgradeDB.createObjectStore(Stores.ExtraInfo, { keyPath: "id" })
      }
      if (!upgradeDB.objectStoreNames.contains(Stores.PrivateKeys)) {
        upgradeDB.createObjectStore(Stores.PrivateKeys, { keyPath: "id" })
      }
      if (!upgradeDB.objectStoreNames.contains(Stores.DownloadFile)) {
        upgradeDB.createObjectStore(Stores.DownloadFile, { keyPath: "id" })
      }
    }

    request.onsuccess = () => {
      db = request.result
      resolve(db)
    }

    request.onerror = () => {
      console.error("Failed to open IndexedDB:", request.error)
      reject(request.error)
    }

    request.onblocked = () => {
      alert("Please close other tabs using this app to complete the update.")
    }
  })
}

export const addData = async <T>(
  storeName: Stores,
  data: T
): Promise<T | string> => {
  try {
    const db = await initDB()
    const tx = db.transaction(storeName, "readwrite")
    const store = tx.objectStore(storeName)
    store.add(data)
    return data
  } catch (err) {
    return (err as Error).message || "Unknown error"
  }
}
export const updateData = async <T>(
  storeName: Stores,
  data: any
): Promise<T | string | null> => {
  try {
    const db = await initDB()
    const tx = db.transaction(storeName, "readwrite")
    const store = tx.objectStore(storeName)

    const res = store.get(data.id)
    res.onsuccess = () => {
      const original = res.result || {}
      const updated = { ...original, ...data }
      const putReq = store.put(updated)
      putReq.onsuccess = () => console.log("Updated successfully")
      putReq.onerror = () => console.error(putReq.error)
    }
    return "Success"
  } catch (error) {
    return (error as Error).message || "Unknown error"
  }
}
export const getStoreData = async <T>(storeName: Stores): Promise<T[]> => {
  const db = await initDB()
  return new Promise((resolve, reject) => {
    const tx = db.transaction(storeName, "readonly")
    const store = tx.objectStore(storeName)
    const res = store.getAll()

    res.onsuccess = () => resolve(res.result)
    res.onerror = () => reject(res.error)
  })
}
export const deleteData = async (
  storeName: Stores,
  key: string
): Promise<boolean> => {
  try {
    const db = await initDB()
    const tx = db.transaction(storeName, "readwrite")
    const store = tx.objectStore(storeName)
    const req = store.delete(key)

    return new Promise((resolve) => {
      req.onsuccess = () => resolve(true)
      req.onerror = () => resolve(false)
    })
  } catch {
    return false
  }
}
